import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment as env } from "../../../../../environments/configs";

@Injectable()
export class TechProfilesListService {

    constructor(private http: HttpClient) {}

    public getClientTechProfilesList(clientId: string | number) {
        const url = `${env.apiPath}/clientTechSpecs?clientId=${clientId}`;
        return this.http.get(url);
    }

    public deleteTechProfiles(payload) {
        const url = `${env.apiPath}/clientTechSpecs/${payload.ids}`;
        return this.http.delete(url);
    }
}
